import React from 'react';
import { Link } from 'react-router-dom';

const Contact = () => {
    return (
        <div className="contact-container">
            <h1>Contact Us</h1>
            <p>If you have any questions or inquiries, feel free to reach out to us!</p>
            <h2>Contact Information</h2>
            <p>Email: info@briqconstruction.com</p>
            <p>Phone: +1 (234) 9999383756</p>
            <p>
                WhatsApp: 
                <a href="https://wa.me/9999383756" target="_blank" rel="noopener noreferrer">
                    Chat with us
                </a>
            </p>
            <h2>Submit Your Query</h2>
            <p>Fill out the form below and we will get back to you shortly.</p>
            <QueryForm />
            <h2>Client Reviews</h2>
            <div className="reviews">
                <p>"BRIQ transformed our home into a masterpiece!" - John D.</p>
                <p>"Professional and reliable service. Highly recommend!" - Sarah K.</p>
                <p>"Their work exceeded our expectations. Amazing team!" - Michael T.</p>
            </div>
            <h2>Explore Our Blog</h2>
            <p>Check out our <Link to="/blog">blog</Link> to see our latest projects and updates.</p>
            <h2>Invest in BRIQ</h2>
            <p>Interested in investing with us? Use our <Link to="/investment-calculator">Investment Calculator</Link> to see your potential returns.</p>
        </div>
    );
};

const QueryForm = () => {
    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission logic here
    };

    return (
        <form onSubmit={handleSubmit}>
            <div>
                <label>Name:</label>
                <input type="text" required />
            </div>
            <div>
                <label>Email:</label>
                <input type="email" required />
            </div>
            <div>
                <label>Message:</label>
                <textarea required></textarea>
            </div>
            <button type="submit">Submit</button>
        </form>
    );
};

export default Contact;